// extracted by mini-css-extract-plugin
export default {"root":"ContainerBuilderWorkflow_root__b2+NG"};